import { useField } from "formik";

import { CheckboxGroup, CheckboxGroupProps } from "./CheckboxGroup";
import { FormFeedback } from "../../../../components/inputs/_assets/input-wrapper/FormFeedback";
import {
  InputWrapperProps,
  InputWrapper,
} from "../../../../components/inputs/_assets/input-wrapper/InputWrapper";

interface Props
  extends CheckboxGroupProps,
    Omit<InputWrapperProps, "children"> {
  name: string;
}

export function CheckboxGroupField({ name, span = "auto", ...props }: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span} testID={props.testID}>
      <CheckboxGroup
        {...field}
        {...props}
        onChange={(value: string[]) => {
          helpers.setValue(value);
        }}
      />
      <FormFeedback>{meta.touched && meta.error}</FormFeedback>
    </InputWrapper>
  );
}
